import React from "react";
import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";

const COLORS = {
  positive: "#10b981",
  neutral: "#facc15",
  negative: "#ef4444",
};

export const NewsSentiment = ({ data }) => {
  if (!data) {
    return (
      <div className="nms-card right-card" data-testid="sentiment-card">
        <div className="rc-head">
          <h3 className="rc-title">
            NEWS
            <br />
            SENTIMENT
          </h3>
        </div>
        <div className="sentiment-empty">Loading…</div>
      </div>
    );
  }
  const total = (data.positive || 0) + (data.neutral || 0) + (data.negative || 0) || 1;
  const pct = (n) => ((n / total) * 100).toFixed(1);

  const chartData = [
    { name: "positive", value: data.positive, pct: pct(data.positive) },
    { name: "neutral", value: data.neutral, pct: pct(data.neutral) },
    { name: "negative", value: data.negative, pct: pct(data.negative) },
  ];

  return (
    <div className="nms-card right-card sentiment-card" data-testid="sentiment-card">
      <div className="rc-head">
        <h3 className="rc-title">
          NEWS
          <br />
          SENTIMENT
        </h3>
      </div>

      <div className="sentiment-body">
        <div className="sentiment-pie">
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie
                data={chartData}
                dataKey="value"
                nameKey="name"
                innerRadius="55%"
                outerRadius="92%"
                stroke="none"
                startAngle={90}
                endAngle={-270}
                isAnimationActive={false}
              >
                {chartData.map((c) => (
                  <Cell key={c.name} fill={COLORS[c.name]} />
                ))}
              </Pie>
            </PieChart>
          </ResponsiveContainer>
          <div className="pie-labels">
            <span className="pl pos">{pct(data.positive)}%</span>
            <span className="pl neu">{pct(data.neutral)}%</span>
            <span className="pl neg">{pct(data.negative)}%</span>
          </div>
        </div>
      </div>

      <div className="sentiment-legend">
        <span data-testid="sentiment-positive">
          <i className="dot pos" /> POSITIVE
        </span>
        <span data-testid="sentiment-neutral">
          <i className="dot neu" /> NEUTRAL
        </span>
        <span data-testid="sentiment-negative">
          <i className="dot neg" /> NEGATIVE
        </span>
      </div>
    </div>
  );
};

export default NewsSentiment;
